import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["box"]

  connect() {
    this.boundHideBox = this.hideBox.bind(this)
  }

  toggle(event) {
    event.stopPropagation()

    document.querySelectorAll("[data-controller='menu-options']").forEach((el) => {
      if (el !== this.element) {
        el.querySelector("[data-menu-options-target='box']")?.classList.add("hidden")
      }
    })

    const isHidden = this.boxTarget.classList.contains("hidden")
    document.removeEventListener("click", this.boundHideBox)

    if (isHidden) {
      this.boxTarget.classList.remove("hidden")
      document.addEventListener("click", this.boundHideBox)
    } else {
      this.boxTarget.classList.add("hidden")
    }
  }

  hideBox(event) {
    if (!this.element.contains(event.target)) {
      this.boxTarget.classList.add("hidden")
      document.removeEventListener("click", this.boundHideBox)
    }
  }
}